import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { BaseDto } from '@authority-labs/api-interfaces';

@Injectable({
  providedIn: 'root'
})
export class EntitySelectorDialogService {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.width = '1000px';
    this.dialogConfig.disableClose = true;
  }

  selectEntity<T extends BaseDto>(
    component: ComponentType<unknown>,
    entityId?: number | string,
    readonly = false
  ): MatDialogRef<unknown, T> {
    this.dialogConfig.data = { entityId, readonly };
    return this.dialog.open(component, this.dialogConfig);
  }
}
